<app-top-nav (orderReportClick)="onTopNavOrderReport()"></app-top-nav>

<div class="info-page-container" xmlns="http://www.w3.org/1999/html">
  <div class="schema-wrapper">
    <router-outlet name="controls"></router-outlet>
  </div>

  <div class="content-container">

    <div class="header" *ngIf="!(breakpointObserverService.isMobile | async) || currentPath.includes(DATA_SOURCES_PATH)">
      <!-- Links, not buttons: a routerLink <button> renders no href, so crawlers
           could not reach one info page from the other. -->
      <a
        routerLink="data-sources"
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: true }">Data sources
      </a>

      <a *ngIf="(accessService.userPlan | async) !== SubscriptionPlans.ENTERPRISE"
        (click)="handleHwwButtonClick()"
        routerLink="healthy-wealthy-and-wise"
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: true }">
        {{(breakpointObserverService.isMobile | async) ? 'HWW Index' : 'Healthy, Wealthy and Wise'}}
      </a>
    </div>

    <div class="header mobile-hww-active" *ngIf="(currentPath.includes(HWW_PATH) && (breakpointObserverService.isMobile | async))">
      <a
        routerLink="data-sources"
        routerLinkActive="selected"
        [ngClass]="{'selected': currentPath.includes(HWW_PATH)}"
        [routerLinkActiveOptions]="{ exact: true }">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2850_10395)">
            <path d="M11.3333 1.33337L4.66663 8.00004L11.3333 14.6667" stroke="#02A4FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_2850_10395">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        Healthy, Wealthy and Wise
      </a>
    </div>

      <router-outlet name="contents"></router-outlet>
  </div>


</div>

<!-- Below the whole page row rather than inside the content card. -->
<router-outlet name="faq"></router-outlet>

<app-site-footer></app-site-footer>
